module.exports = __webpack_public_path__ + "static/media/user-slash.cdbf4c15.svg";